import React from 'react';
import ServiceCard from '../components/ServiceCard';
import site from '../content/siteContent';

export default function Services() {
  return (
    <div className="min-h-screen bg-sand/5">
      {/* Hero Section */}
      <div className="bg-wood text-sand py-16">
        <div className="container">
          <h1 className="text-4xl font-bold mb-4">Our Services</h1>
          <p className="text-sand/90 max-w-2xl text-content">
            From modular kitchens to complete office interiors, we offer end-to-end interior
            solutions that combine functionality with aesthetic excellence.
          </p>
        </div>
      </div>

      <div className="container py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {site.services.map((it, idx) => {
            // simple icon mapping based on keywords
            let icon = null;
            if (/kitchen/i.test(it.title))
              icon = (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="3"
                    y="6"
                    width="18"
                    height="12"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M7 6v-2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              );
            else if (/wardrobe|furniture/i.test(it.title))
              icon = (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="4"
                    y="4"
                    width="7"
                    height="16"
                    rx="1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <rect
                    x="13"
                    y="4"
                    width="7"
                    height="16"
                    rx="1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
              );
            else if (/ceiling/i.test(it.title))
              icon = (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3 8h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  <path
                    d="M6 12h12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              );
            else if (/wall|panelling/i.test(it.title))
              icon = (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M4 6h16v12H4z" stroke="currentColor" strokeWidth="1.5" />
                  <path d="M8 6v12" stroke="currentColor" strokeWidth="1.5" />
                </svg>
              );
            else if (/tv|entertainment/i.test(it.title))
              icon = (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="3"
                    y="5"
                    width="18"
                    height="12"
                    rx="1.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path d="M8 20h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              );
            else
              icon = (
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.5" />
                </svg>
              );

            return (
              <ServiceCard key={idx} title={it.title} icon={icon}>
                {it.description}
              </ServiceCard>
            );
          })}
        </div>
      </div>
    </div>
  );
}
